"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScheduleYourFreeInspection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="141502" id="request-your-quote" className="relative py-24 bg-background text-foreground overflow-hidden" ref={ref}>
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585014/img/topographic_pattern_bg.png)] opacity-[0.05] bg-cover bg-center mix-blend-overlay pointer-events-none" />
      
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className={cn("max-w-[800px] mx-auto transition-all duration-1000 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <div className="text-center mb-10">
            
            
          </div>

        </div>
      </div>
    </section>;
}